import { Component } from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-landing-feature',
  imports: [
    TranslocoPipe,
    RouterLink
  ],
  templateUrl: './landing-feature.component.html',
  styleUrl: './landing-feature.component.scss'
})
export class LandingFeatureComponent {

}
